import React from 'react'
import { Editable, Slate, withReact } from 'slate-react'
import { compose } from 'ramda'
import { createEditor } from 'slate'
import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'

import { Absolute, Relative } from '../../../kiti/components/helpers/Position'
import { deserializeText, serializeText } from '../_serializers/textSerializer'
import { renderElement, renderLeaf } from '../_plugins/plugins'
import { useEditorKeydown } from '../_plugins/keydowns'
import EditorContext from '../EditorContext'
import InterpolationPlugin from '../_plugins/InterpolationPlugin'
import Panel from '../../../kiti/components/structure/Panel'
import Separator from '../../../kiti/components/helpers/Separator'
import { resetNodes } from './_helpers/resetNodes'
import Link from '../../../../components/actions/Link'
import { SmallText } from '../../../kiti/components/presentation/Text'

const InputWithInterpolations = ({ value, onChange, interpolations, singleLine, clearButton = false }) => {
  const [editor] = React.useState(() =>
    compose(InterpolationPlugin.extend({ fullControl: false }), withReact)(createEditor())
  )
  editor.singleLine = singleLine
  const initialValue = React.useMemo(() => deserializeText(value || '', interpolations), [])
  const { t } = useTranslation('common')

  const handleClear = () => {
    resetNodes(editor, { nodes: [{ type: 'paragraph', children: [{ text: '' }] }] })
    onChange()
  }

  return (
    <>
      <Panel padding={0} radius={0.3} borderColor={COLORS.light5}>
        <Slate editor={editor} value={initialValue} onChange={compose(onChange, serializeText)}>
          <EditorContext size="small">
            <Relative zIndex="auto">
              <Separator paddingV={0.6} paddingH={0.7}>
                <Editable onKeyDown={useEditorKeydown(editor)} renderElement={renderElement} renderLeaf={renderLeaf} />

                <Absolute right={0} top={-1.5} zIndex="auto">
                  <InterpolationPlugin.Dropdown options={interpolations} />
                </Absolute>
              </Separator>
            </Relative>
          </EditorContext>
        </Slate>
      </Panel>
      {!!value && clearButton && (
        <>
          <Separator weight={4} />
          <Link onClick={() => handleClear()}>
            <SmallText bold color={COLORS.red}>
              {t('removeInitialValue')}
            </SmallText>
          </Link>
        </>
      )}
    </>
  )
}

export default InputWithInterpolations
